export const NOTIFICATION_SET_SOUND = 'NOTIFICATION_SET_SOUND';

export const setSound = (value: boolean) => ({
    type: NOTIFICATION_SET_SOUND,
    payload: { value },
});
